import {FC} from "react";
import Header from "@memaro/components/Header.tsx";
import Menu from "./Menu.tsx";

const ProfileNotFound: FC = () => (
    <>
        <Menu />
        <Header>Niet gevonden</Header>
        <p>
            De herinnneringspagina die u probeert te bekijken bestaat niet, of u heeft geen rechten om deze pagina te
            bekijken.
        </p>
    </>
)

export  default ProfileNotFound
